import React, { FC, useRef, useState } from "react";
import classNames from "classnames";
import { AppInfo } from "../types";
import { Dropdown, Menu, Modal } from "antd";
import { IconFont } from "@/components/IconFont";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.less";
import { openApp } from "../openApp";
import { detectBrowser, BrowserInfo } from "@/utils/detectBrowser";
import { isBrowserSupportAsa } from "@/utils";
import { ExclamationCircleOutlined } from '@ant-design/icons'

export interface PCAndPadAppItemCardProps {
  appInfo: AppInfo;
  onRemoveApp: (appInfo: AppInfo) => any;
}

export const PCAndPadAppItemCard: FC<PCAndPadAppItemCardProps> = React.memo(
  ({ appInfo, onRemoveApp }) => {
    const { t } = useTranslation();
    const dropdownRef = useRef(null);

    const [menuVisible, setMenuVisible] = useState(false);

    const menu = (
      <Menu>
        <Menu.Item>
          <div
            className={styles.editTipFloat}
            onClick={() => onRemoveApp(appInfo)}
          >
            <IconFont type="authing-delete-bin-6-line" />
            <span className={styles.deleteText}>{t("common.deleteApp")}</span>
          </div>
        </Menu.Item>
      </Menu>
    );

    return (
      <div
        className={classNames(styles.appItem)}
        // TODO iPhone 无法点击再加回来
        onClick={() => {
          const browserInfo = detectBrowser();

          // 支持 ASA 的浏览器且没有安装插件
          if (appInfo.isAsa && browserInfo instanceof BrowserInfo && isBrowserSupportAsa(browserInfo) && !document.getElementById("_authing_asa_plugin_info_")) {
            Modal.confirm({
              title: t('user.asa.installPlugin'),
              icon: <ExclamationCircleOutlined style={{
                fontSize: 17,
                marginTop: 3
              }} />,
              content: t('user.asa.installPluginDesc'),
              okText: t('user.asa.viewInstallDoc'),
              cancelText: t('common.cancel'),
              className: styles.customConfirm,
              okButtonProps: {
                style: {
                  marginLeft: 16
                }
              },
              onOk() {
                window.open(`${window.__config__?.docs?.host}/guides/asa/`)
              }
            });

            return
          }

          // iphon 和 ipad 上无法点击
          // if (!isIPhonOrIPad()) {
          openApp(appInfo);
          // }
        }}
        // onTouchEnd={() => {
        //   if (isIPhonOrIPad()) {
        //     openApp(appInfo);
        //   }
        // }}
        onMouseLeave={() => setMenuVisible(false)}
      >
        <div
          ref={dropdownRef}
          // 阻止打开新页面
          onClick={(evt) => {
            evt.stopPropagation();
          }}
          className={classNames(styles.dropdownContainer)}
          data-disable-drag="1"
        >
          <Dropdown
            overlay={menu}
            getPopupContainer={() => dropdownRef.current || document.body}
            placement="bottomCenter"
            trigger={["click"]}
            visible={menuVisible}
            onVisibleChange={setMenuVisible}
          >
            <IconFont
              type="authing-more-fill"
              className={styles.dropdownTrigger}
            />
          </Dropdown>
          {/* <IconFont type="authing-more-fill" /> */}
        </div>
        <div className={styles.appLogoWrap}>
          <img
            src={appInfo.logo}
            alt=""
            draggable={false}
            className={styles.logo}
          />
        </div>
        <p className={styles.appName}>{appInfo.name}</p>
      </div>
    );
  }
);
